import React from "react";
import { useAuth } from "../../../../firebase/AuthContext";
import openAdmin from "../docsAssets/openAdmin_demo.mp4";
import changeRole from "../docsAssets/changeRole_demo.mp4";
import changeGroup from "../docsAssets/changeGroup_demo.mp4";

export default function AdminPanel({ isEN }) {
  const { currentUser, hasRole } = useAuth();

  if (!currentUser) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
            {/* Header with icon */}
            <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-8 text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">
                {isEN ? "Access Required" : "需要存取權限"}
              </h2>
              <p className="text-orange-100 text-sm">
                {isEN ? "Troubleshooting Guide" : "故障排除指南"}
              </p>
            </div>

            {/* Content */}
            <div className="px-6 py-8">
              <div className="text-center mb-6">
                <h3 className="text-gray-800 dark:text-white font-semibold text-lg mb-3">
                  {isEN ? "Please log in to continue" : "請登入以繼續"}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                  {isEN
                    ? "You need to be authenticated to access the troubleshooting guide and technical support resources."
                    : "您需要進行身份驗證才能存取故障排除指南和技術支援資源。"}
                </p>
              </div>

              {/* Features preview */}
              <div className="space-y-3 mb-8">
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                  {isEN ? "Common issues & solutions" : "常見問題和解決方案"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  {isEN ? "Step-by-step guides" : "逐步指南"}
                </div>
                <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                  {isEN ? "Direct support contact" : "直接支持聯繫"}
                </div>
              </div>

              {/* Login prompt */}
              <div className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
                <p className="text-center text-gray-700 dark:text-gray-300 text-sm">
                  {isEN
                    ? "Return to the main page to sign in with your account"
                    : "返回主頁面使用您的帳號登入"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                        />
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "Admin Panel" : "管理者面板"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN
              ? "A guide to managing user profiles and understanding permissions"
              : "管理使用者資料和理解權限的指南"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-lg p-6 border border-gray-600 shadow-lg">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
              {isEN ? "Administrative Controls" : "管理控制"}
            </h3>
          </div>

          <div className="space-y-6">
            <div className="bg-red-500 rounded-lg p-6 text-white shadow-lg">
              <div className="flex items-center mb-3">
                {/* <div className="w-6 h-6 bg-white bg-opacity-20 rounded-lg flex items-center justify-center mr-3">
                                    <svg
                                        className="w-4 h-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 18.5c-.77.833.192 2.5 1.732 2.5z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="font-semibold">
                  {isEN
                    ? "Administrator Access Required"
                    : "需要管理員存取權限"}
                </h4>
              </div>
              <p className="text-red-100 text-sm">
                {isEN
                  ? "This section is only accessible to users with administrator privileges. Contact your system administrator if you need access."
                  : "此部分僅對具有管理員權限的使用者開放。如需存取權限，請聯絡您的系統管理員。"}
              </p>
            </div>

            {hasRole && hasRole("admin_panel.access") && (
              <div>
                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <div className="flex items-center mb-4">
                    {/* <div className="w-6 h-6 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
                                        />
                                    </svg>
                                </div> */}
                    <h4 className="text-gray-800 dark:text-white font-semibold text-xl">
                      {isEN ? "User Management" : "使用者管理"}
                    </h4>
                  </div>
                  <div className="bg-gray-900 rounded-lg overflow-hidden shadow-inner border border-gray-700 mb-4">
                    <video
                      src={openAdmin}
                      className="w-full object-cover"
                      controls
                    />
                  </div>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-3">
                      <h5 className="text-orange-600 dark:text-orange-400 text-sm font-semibold flex items-center">
                        {isEN ? "User Operations:" : "使用者操作:"}
                      </h5>
                      <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                          {isEN ? "View all users" : "查看所有用戶"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                          {isEN ? "Create new accounts" : "建立新帳戶"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                          {isEN ? "Edit user profiles" : "編輯使用者資料"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                          {isEN ? "Suspend/activate accounts" : "暫停/啟動帳戶"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                          {isEN ? "Reset passwords" : "重設密碼"}
                        </li>
                      </ul>
                    </div>
                    <div className="space-y-3">
                      <h5 className="text-green-600 dark:text-green-400 text-sm font-semibold flex items-center">
                        {isEN ? "Role Management:" : "角色管理:"}
                      </h5>
                      <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {isEN ? "Assign user roles" : "指派使用者角色"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {isEN ? "Create custom roles" : "建立自訂角色"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {isEN ? "Modify permissions" : "修改權限"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {isEN
                            ? "Role-based access control"
                            : "基於角色的存取控制"}
                        </li>
                        <li className="flex items-center">
                          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                          {isEN ? "Audit role changes" : "審計角色變更"}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <h4 className="text-gray-800 dark:text-white font-semibold mb-3 text-xl">
                    {isEN ? "User Permissions" : "使用者權限"}
                  </h4>
                  <p className="text-gray-800 dark:text-white text-sm mb-3">
                    {isEN
                      ? "Every account has specific permissions based on the role. Each role is related with each group, to change the access of each user it can be done with changing the role that is connected to the user group."
                      : "每個帳戶都有基於角色的特定權限。每個角色都與每個群組相關聯，要更改每個使用者的存取權限，可以透過更改與使用者群組連接的角色來完成。"}
                  </p>
                  <div className="grid md:grid-cols-3 gap-3">
                    <div className="bg-gray-800 rounded p-3">
                      <div className="text-green-400 text-xs font-medium mb-1">
                        User
                      </div>
                      <ul className="text-gray-300 text-xs space-y-1">
                        <li>• {isEN ? "Chat access" : "聊天訪問"}</li>
                        <li>• {isEN ? "Profile editing" : "編輯個人資料"}</li>
                        <li>• {isEN ? "Basic features" : "基本功能"}</li>
                      </ul>
                    </div>
                    <div className="bg-gray-800 rounded p-3">
                      <div className="text-yellow-400 text-xs font-medium mb-1">
                        Editor
                      </div>
                      <ul className="text-gray-300 text-xs space-y-1">
                        <li>
                          • {isEN ? "All standard features" : "所有標準功能"}
                        </li>
                        <li>
                          • {isEN ? "Data Edit & Upload" : "數據編輯與上傳"}
                        </li>
                      </ul>
                    </div>
                    <div className="bg-gray-800 rounded p-3">
                      <div className="text-red-400 text-xs font-medium mb-1">
                        ADMIN
                      </div>
                      <ul className="text-gray-300 text-xs space-y-1">
                        <li>• {isEN ? "All features" : "所有功能"}</li>
                        <li>• {isEN ? "User management" : "使用者管理"}</li>
                        <li>• {isEN ? "System settings" : "系統設定"}</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <h4 className="text-gray-800 dark:text-white font-semibold text-xl mb-3">
                    {isEN ? "Admin Best Practices" : "管理員最佳實踐"}
                  </h4>
                  <ul className="text-gray-600 dark:text-gray-400 text-sm space-y-2">
                    <li className="flex items-start space-x-2">
                      <span className="text-yellow-400 ">•</span>
                      <span>
                        {isEN
                          ? "Regularly review user permissions and remove unnecessary access"
                          : "定期檢查使用者權限並刪除不必要的存取權限"}
                      </span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-yellow-400 mt-1">•</span>
                      <span>
                        {isEN
                          ? "Monitor system logs for unusual activity patterns"
                          : "監控系統日誌中的異常活動模式"}
                      </span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-yellow-400 mt-1">•</span>
                      <span>
                        {isEN
                          ? "Keep system backups current and test restoration procedures"
                          : "保持系統備份最新並測試復原程序"}
                      </span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <span className="text-yellow-400 mt-1">•</span>
                      <span>
                        {isEN
                          ? "Document all administrative changes for audit purposes"
                          : "記錄所有管理變更以便審計"}
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <h4 className="text-gray-800 dark:text-white font-semibold text-xl mb-3">
                    {isEN ? "Assign Group for User" : "為使用者分配群組"}
                  </h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="p-2 bg-slate-300/10 rounded-md">
                      <video
                        src={changeGroup}
                        className="w-full h-full rounded-md object-cover"
                        controls
                      />
                    </div>
                    <div className="text-gray-500 dark:text-gray-400 text-sm flex flex-col justify-center">
                      {isEN
                        ? "The start of user management is assigning groups to users. Each group can have different roles and permissions."
                        : "使用者管理的開始是為使用者分配群組。每個群組可以有不同的角色和權限。"}
                      <hr className="my-2" />
                      {isEN
                        ? "To assign group to a user, navigate to the 'Users' section in the admin panel. Select the desired user, then choose the appropriate group from the dropdown menu and save the changes."
                        : "若要為使用者指派群組，請導覽至管理面板中的「使用者」部分。選擇所需的用戶，然後從下拉式選單中選擇適當的群組並儲存變更。"}
                      <hr className="my-2" />
                      {isEN
                        ? "After assigning group changes, the selected user will need to refresh their authentication token to receive the updated permissions. This can typically be done by logging out and back in, or by using a 'Refresh Token' button if available."
                        : "在分配群組變更後，所選使用者需要刷新其身份驗證令牌以接收更新的權限。通常可以透過登出並重新登錄，或使用「刷新令牌」按鈕（如果可用）來完成此操作。"}
                    </div>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <h4 className="text-gray-800 dark:text-white font-medium mb-3 text-xl">
                    {isEN ? "Assign Roles for Group" : "為群組分配角色"}
                  </h4>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="text-gray-500 dark:text-gray-400 text-sm flex flex-col justify-center">
                      {isEN
                        ? "To control access and permissions we can assign roles to certain groups. Each role has specific permissions that define what actions users in that group can perform."
                        : "使用者可以為特定群組分配角色以控制存取和權限。每個角色都有特定的權限，定義了該群組使用者可以執行的操作。"}
                      <hr className="my-2" />
                      {isEN
                        ? "To assign roles to a group, navigate to the 'Groups' section in the admin panel. Select the desired group, then choose the appropriate role from the dropdown menu and save the changes."
                        : "若要為群組指派角色，請導覽至管理面板中的「群組」部分。選擇所需的群組，然後從下拉式選單中選擇適當的角色並儲存變更。 "}
                      <hr className="my-2" />
                      {isEN
                        ? "After assigning role changes, users in that group will need to refresh their authentication token to receive the updated permissions. This can typically be done by logging out and back in, or by using a 'Refresh Token' button if available."
                        : "在指派角色變更後，該群組中的使用者需要刷新其身份驗證令牌以接收更新的權限。通常可以透過登出並重新登錄，或使用「刷新令牌」按鈕（如果可用）來完成此操作。"}
                    </div>
                    <div className="p-2 bg-slate-300/10 rounded-md">
                      <video
                        src={changeRole}
                        className="w-full h-full rounded-md object-cover"
                        controls
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
                  <h4 className="text-gray-800 dark:text-white font-semibold text-xl mb-3">
                    {isEN ? "Usage & Billing" : "用量與計費"}
                  </h4>
                  <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">
                    {isEN
                      ? "The 'Usage & Billing' tab shows what each user's AI use in TG PIMS Agent costs, in USD, and lets you set limits on it. Admins and users with manage_all_groups or monitor_logs can open it; only admins and manage_all_groups can change anything."
                      : "「用量與計費」分頁顯示每位使用者在 TG PIMS Agent 的 AI 使用費用（美元），並可設定額度。管理員以及擁有 manage_all_groups 或 monitor_logs 角色的使用者可以查看；只有管理員與 manage_all_groups 可以變更設定。"}
                  </p>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="space-y-3">
                      <h5 className="text-orange-600 dark:text-orange-400 text-sm font-semibold">
                        {isEN ? "How limits work" : "額度如何運作"}
                      </h5>
                      <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "A 'monthly' limit covers one 28-day cycle. Cycles started on Thursday 8 Oct 2026 and are the same for everyone."
                            : "「每月」額度涵蓋一個 28 天的週期。週期自 2026 年 10 月 8 日（週四）開始，所有人相同。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "It is paced weekly (Thursday to Thursday): each week gets a quarter of the limit, plus whatever went unused earlier in the cycle. A new cycle starts fresh."
                            : "額度按週分配（週四到週四）：每週可用四分之一，加上本週期前幾週未用完的部分。新週期重新開始。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "A limit is per user, not a budget the group shares. It comes from the user's group unless you give them an override: 'this cycle only', or permanent. This cycle's override wins, then the permanent one, then the group's."
                            : "額度是每位使用者各自的，不是群組共用的預算。額度來自使用者的群組，除非另外設定個人額度（僅本週期或永久）。優先順序：僅本週期 → 永久個人額度 → 群組額度。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-orange-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "Changes apply immediately, and every change is written to the audit log."
                            : "變更立即生效，並會記錄在審計日誌中。"}
                        </li>
                      </ul>
                    </div>
                    <div className="space-y-3">
                      <h5 className="text-red-600 dark:text-red-400 text-sm font-semibold">
                        {isEN ? "Enforcement and unpriced calls" : "限制開關與未計價的呼叫"}
                      </h5>
                      <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "Usage is always recorded. Users are only blocked when the enforcement switch is on: then a user who reaches this week's quota can't ask TG PIMS Agent anything until the week resets."
                            : "用量一律會記錄。只有在限制開關開啟時才會封鎖使用者：用完本週額度的使用者，在下週重置前無法再向 TG PIMS Agent 提問。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "Turning enforcement on blocks real users from their next question, so the tab asks you to confirm."
                            : "開啟限制會立即封鎖已超過額度的使用者，因此需要再次確認。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "A user with no limit at all (no group limit, no override) is never blocked. They show as 'No limit' in amber."
                            : "完全沒有額度的使用者（沒有群組額度也沒有個人額度）永遠不會被封鎖，會以橘色「未設定額度」標示。"}
                        </li>
                        <li className="flex items-start">
                          <div className="w-2 h-2 bg-red-500 rounded-full mr-2 mt-1.5 shrink-0"></div>
                          {isEN
                            ? "'Unpriced calls' are model calls whose usage couldn't be measured. They count as $0, so the real cost is somewhat higher than the totals shown."
                            : "「未計價的呼叫」是無法量測用量的模型呼叫，以 $0 計入，因此實際成本會比顯示的總額略高。"}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
